import type { BucketCardProps } from 'bundles/front-page/components/modules/buckets/BucketCard';

import LOHPBucket1 from 'images/front-page/LOHPBucket1.png';
import LOHPBucket2 from 'images/front-page/LOHPBucket2.png';
import LOHPBucket3 from 'images/front-page/LOHPBucket3.png';

import _t from 'i18n!nls/front-page';

export const getMockBucketData = (): BucketCardProps[] => [
  {
    imageUrl: LOHPBucket1,
    title: _t('Get in-demand Ai skills'),
    body: _t('Get training in a high-growth fields from companies like Google, Meta, and IBM.'),
    url: '/explore/generative-ai',
  },
  {
    imageUrl: LOHPBucket2,
    title: _t('Start a new career'),
    body: _t('Learn high-income skills—like data analysis and machine learning—through self-paced courses.'),
    url: '/campus/career-academy',
  },

  {
    imageUrl: LOHPBucket3,
    title: _t('Earn a degree'),
    body: _t('Enroll in a flexible, 100% online degree program to start or advance your career.'),
    url: '/degrees',
  },
];
